// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2O1yY","header":"Messages_header__sxOXH"};